import { Card, CountryCard } from "ui";
import { countryWiseDownloads } from "assets/data/dashboard";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
const CountryWiseDownload = () => {
    const [countries, setCountries] = useState(countryWiseDownloads);
    const [filter, setFilter] = useState("");

    const handleChangeFilter = () => {
        if (filter != "") {
            const arr = countryWiseDownloads.filter(
                (c) => c.country.indexOf(filter) > -1
            );
            setCountries(arr);
        } else {
            setCountries(countryWiseDownloads);
        }
    };

    useEffect(() => {
        handleChangeFilter();
    }, [filter]);

    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">Country Wise Download</h2>
                <TextField
                    id="search-country-wise-download"
                    name="search-country-wise-download"
                    label="Search"
                    variant="outlined"
                    size="small"
                    sx={{ width: "100%" }}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                />
            </div>
            <div className="flex flex-col justify-start items-center gap-5 px-2 py-2 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto">
                {countries.map((c) => (
                    <CountryCard country={c} key={c.country} />
                ))}
            </div>
        </Card>
    );
};

export default CountryWiseDownload;
